module.exports = {
  username: "root",
  password: "root"
}


//////////////////
// WEBPACK FOOTER
// ./config/db.js
// module id = 319
// module chunks = 23